import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class SpeechRecognitionResult extends React.Component {

  renderWords(word, index) {
    if (word.length === 0) {
      return <span key={index} />;
    }

    let color = 'transparent';
    let opaqueColor: 'transparent';
    let style;
    const scoreByWord = this.props.scoreByWord[index];

    if (scoreByWord >= 75) {
      color = 'rgba(0,128,0,1)';
    } else if ((scoreByWord >= 50) && (scoreByWord < 75)) {
      color = 'rgba(255,255,0,1)';
      opaqueColor = 'rgba(255,255,0,0.1)';
    } else if ((scoreByWord >= 25) && (scoreByWord < 50)) {
      color = 'rgba(255,165,0,1)';
      opaqueColor = 'rgba(255,165,0,0.1)';
    } else {
      color = 'rgba(255,0,0,1)';
      opaqueColor = 'rgba(255,0,0,0.1)';
    }

    if (scoreByWord >= 75) {
      style = {
        color,
      };
    } else {
      style = {
        borderBottom: `2px solid ${color}`,
        background: opaqueColor,
      };
    }

    return <span key={index}><span style={style}>{word}</span>&nbsp;</span>;
  }

  render() {
    if (this.props.isRecording) {
      return <div className="pronounce-speech-rec-result" />;
    }

    const words = this.props.result.split(' ');
    return (
      <div className="pronounce-speech-rec-result">
        <ReactCSSTransitionGroup
          transitionName="example"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {words.map((key, index) => this.renderWords(key, index))}
        </ReactCSSTransitionGroup>
      </div>
        );
  }
}

export default SpeechRecognitionResult;



// WEBPACK FOOTER //
// ./src/components/SpeechRecognitionResult.js